<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page6-5')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero elegir la mejor condición para contratar mi Crédito Hipotecario!
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B') PREGUNTA
            v-card-text.titulo24Reg.text-center
              | De las siguientes opciones, ¿cuál le recomendarías tú?
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | Marca la respuesta correcta:
              v-radio-group(v-model='respuesta')
                v-layout.ml-5(v-for='(reactivo, index) in reactivos', :key='index')
                  v-flex.iconos.text-xs-center.pt-3(xs1, align-center, align-content-center)
                    div(v-if='sent && (correcta == index || respuesta == index)')
                      v-icon(size='15px', color='green', v-if='sent && (correcta == index)') fas fa-check
                      v-icon(size='15px', color='red', v-if='sent && (correcta != index)') fas fa-times
                  v-flex.iconos.text-xs-right(xs1, align-content-center)
                    v-radio(hide-details, :value='index')
                  v-flex.label16tt_blue.text-xs-left.pr-5(xs12, align-content-center)
                    div(style="display:inline;" v-html="reactivo.descripcion").mx-2.pr-5.parrafoDestacadoB
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false')
                  v-btn.btn(color='secondary', v-bind:class='responseIsNone', :disabled="respuesta=='none'", @click='sendResult()')
                    | Enviar
                div(v-if='sent')
                  v-btn.btn(color='accent', style='z-index:2', @click.prevent='dialog=true')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog', persistent, max-width='930px')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1.pr-2(v-if='sent && (respuesta==correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                          .pt-1.pr-2(v-if='sent && (respuesta!=correcta)')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                          v-card.px-5.questionCard(justify-center, flat)
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==0)')
                              v-card-text.dialog_text
                                | ¡Podría ser! Pero aunque un crédito mancomunado te ayuda a incrementar tu capacidad de pago y, por consecuencia, aumentar el monto del crédito, es exclusivo para parejas.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==1)')
                              v-card-text.dialog_text
                                b ¡Gran consejo! 
                                .pt-3 !Esta opción es la más viable para completar su Crédito Hipotecario. Al cotizar ante FOVISSSTE o INFONAVIT, cuenta con esta prestación. 
                                .pt-3 Entre más tiempo lleves cotizando en alguno de estos fondos, tendrás más posibilidades de ampliar tu crédito.
                            .pt-1.px-5.text-sm-left(v-if='sent && (respuesta==2)')
                              v-card-text.dialog_text
                                | Un fondo de inversión es una excelente opción a largo plazo. Sin embargo, no es suficiente para incrementar tu capacidad inmediata de pago.
                          v-btn.btn.dialog_btn(color='accent', @click.prevent="nextPage('page6-7')")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      reactivos: [{
          descripcion: 'Unir sus ingresos con los de uno de sus padres y solicitar un crédito mancomunado. ',
        },
        {
          descripcion: 'Revisar cuánto tiene ahorrado en su fondo de vivienda y explorar la posibilidad de un cofinanciamiento',
        },
        {
          descripcion: 'Asignar una cantidad fija a un fondo de inversión que le genere una ganancia extra y, por lo tanto, incremente su capacidad de pago.',
        }
      ],
      selected: [],
      respuesta: 'none',
      response: 0,
      correcta: 1,
      sent: false,
      feedback: false,
      dialog: false
    }
  },
  methods: {
    sendResult() {
      if (this.respuesta == this.correcta) {
        this.response = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.response);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    },
    checkResult() {
      return {
        'done': this.response != 'none',
        'clear': this.response == 'none'
      }
    }
  }
};
</script>
